// extracted by mini-css-extract-plugin
module.exports = {"nav-wrapper":"SliderNumberIndicator_nav-wrapper__XYsYJ","text":"SliderNumberIndicator_text__R7Y2i"};